import { ButtonHTMLAttributes, ReactElement } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    title: string;
    children: ReactElement;
}
export function StyledContainer({ title, children }: Props): ReactElement {
  return (
    <div className="styled-container">
      <h2 className="title">{title}</h2>
      <p>{children}</p>
    </div>
  );
};

export default StyledContainer;